<template>
  <div class="auth-banner" @click="handleBannerClick">
    <div class="auth-banner__background" />
    <div class="auth-banner__title">{{ t('signupNow') }}</div>
    <div
      v-for="feature in featuresList"
      :key="feature.title"
      class="auth-banner__text"
    >
      <div>{{ feature.title }}</div>
      <div v-if="feature.isComingSoon" class="auth-banner__coming-soon">
        {{ t('comingSoon') }} <img src="/assets/icon/fire-icon.svg" alt="" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useInternalization } from '@/composables/useInternalization';
import { useRouter } from 'vue-router';

const router = useRouter();
const { t } = useInternalization();

const featuresList: { title: string; isComingSoon?: boolean }[] = [
  { title: t('authFeatureList[0]') },
  { title: t('authFeatureList[1]') },
  { title: t('authFeatureList[2]') },
  { title: t('authFeatureList[3]') },
  { title: t('authFeatureList[4]') },
];

function handleBannerClick() {
  router.push({ name: 'Auth' });
}
</script>

<style lang="scss" scoped>
.auth-banner {
  border-radius: 20px;
  padding: 16px;
  color: #172659;
  position: relative;
  overflow: hidden;
  cursor: pointer;

  &__background {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    height: 100%;
    width: 100%;
    background: #edf5fd;

    &::after {
      content: '';
      display: block;
      width: 40vh;
      height: 40vh;
      background: rgba(255, 255, 255, 0.5);
      border-radius: 50%;
      position: absolute;
      z-index: 0;
      right: 0;
      bottom: -50%;
    }
  }

  &__title {
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    margin-bottom: 12px;
  }

  &__text {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 15px;
    line-height: 20px;

    &:not(:last-child) {
      margin-bottom: 5px;
    }
  }

  &__coming-soon {
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
    color: #ff6854;
    display: flex;
    align-items: center;

    img {
      background: #fff;
      padding: 4px 6px;
      border-radius: 4px;
      margin-left: 8px;
    }
  }
}
</style>
